import React from 'react';
import FormatSettings from './Configuration/FormatSettings';
import LabelsSettings from './Configuration/LabelsSettings';
import PlayerSettings from './Configuration/PlayerSettings';
import PublisherSettings from './Configuration/PublisherSettings';
import RTBSettings from './Configuration/RTBSettings';
import VpaidSettings from './Configuration/VpaidSettings';
import $ from 'jquery';
import { setLocalStorage, validateField, updateSize } from '../../../helpers/tools';

class Configuration extends React.Component {
  constructor(props) {
    super(props);
    this.sections = {
      publisher: { isValid: true },
      player: { isValid: true },
      vpaid: { isValid: true },
      rtb: { isValid: true },
      labels: { isValid: true },
      overlays: { isValid: true },
      companions: { isValid: true },
    };
  }

  componentDidMount() {
    updateSize();
  }

  //show hidden filed from more section if has some error
  expandHiddenFields = (event, errorItem) => {
    if ($(event.target).get(0).className === 'textFiled textFiledError') {
      let parentDiv = $(errorItem).parent().parent().parent();
      if (parentDiv.get(0) !== undefined && parentDiv.get(0).className === 'more') {
        $(parentDiv).css('display', 'block');
        $(parentDiv).parent().find('.moreButton').text('Show less options');
      }
    }
  };
  handleOptionChange = (event, caller, valueType) => {
    const target = event.target,
      configurationSection = caller.section;

    let value = target.type === 'checkbox' ? target.checked : target.value,
      name = target.name;

    if (target.type === 'radio') {
      globalThis.scrollTo(0, globalThis.lastScrolledValue);
    }

    if (valueType === Boolean) {
      value = value === 'true' ? true : false;
    }

    let conf = this.props.data,
      valid = true;
    this.sections[configurationSection].isValid = this.isValid(event, caller);

    Object.keys(this.sections).forEach(
      (item => {
        valid = valid && this.sections[item].isValid;
      }).bind(this)
    );

    conf.isValid = valid;
    if (!conf[configurationSection]) conf[configurationSection] = {};
    conf[configurationSection][name] = value;

    this.props.updateState(conf);
  };
  isValid = (event, scope) => {
    let isValid = true,
      errorItem = $(event.target).parent().find('.validationError');

    if (scope.invalidFileds.includes(event.target.name)) {
      const index = scope.invalidFileds.indexOf(event.target.name);
      scope.invalidFileds.splice(index, 1);
    }
    if ($(errorItem).get(0)?.style?.display === 'block') {
      isValid = false;
      scope.invalidFileds.push(event.target.name);
    }
    setLocalStorage(scope.section + 'errors', JSON.stringify(scope.invalidFileds));
    this.expandHiddenFields(event, errorItem);

    return isValid && !scope.invalidFileds.length;
  };

  validate = (event, type, required, caller) => {
    const valueType = type === 'number' ? Number : String,
      minValue = event.target.min ? Number.parseInt(event.target.min, 10) : null,
      maxValue = event.target.max ? Number.parseInt(event.target.max, 10) : null;
    validateField(
      event,
      type,
      required,
      this.handleOptionChange.bind(this, event, caller, valueType),
      minValue,
      maxValue
    );
  };

  render() {
    return (
      <div className="expand-wrapper">
        <PublisherSettings
          handleOptionChange={this.handleOptionChange}
          toggleElement={this.props.toggleElement}
          validate={this.validate}
          publisher={this.props.data.publisher}
        />
        <div className="divider"></div>
        <PlayerSettings
          handleOptionChange={this.handleOptionChange}
          toggleElement={this.props.toggleElement}
          validate={this.validate}
          player={this.props.data.player}
        />
        <div className="divider"></div>
        <FormatSettings
          handleOptionChange={this.handleOptionChange}
          toggleElement={this.props.toggleElement}
          validate={this.validate}
          overlays={this.props.data.overlays}
          companions={this.props.data.companions}
        />
        <div className="divider"></div>
        <VpaidSettings
          handleOptionChange={this.handleOptionChange}
          toggleElement={this.props.toggleElement}
          validate={this.validate}
          vpaid={this.props.data.vpaid}
        />
        <div className="divider"></div>
        <RTBSettings
          handleOptionChange={this.handleOptionChange}
          toggleElement={this.props.toggleElement}
          validate={this.validate}
          rtb={this.props.data.rtb}
        />
        <div className="divider"></div>
        <LabelsSettings
          handleOptionChange={this.handleOptionChange}
          toggleElement={this.props.toggleElement}
          validate={this.validate}
          labels={this.props.data.labels}
        />
      </div>
    );
  }
}

export default Configuration;
